export default "__VITE_ASSET__173ce332__"